// extracted by mini-css-extract-plugin
export default {"cls1":"TTueJHsdY2ZeFcnVrIUw","cls2":"ORyvMyvVJWylK0JL5oQQ TTueJHsdY2ZeFcnVrIUw","selected":"hzgRdXXm_6X_3r9vVxHG","zoom":"sMyVS9zavAvm7jUVd_qR","hasInvitees":"JGc5qCfpfqpwCCboKXzo"};